<template>
  <!--滑动banner -->
  <div :class="['swiperbanner_container', { 'container-dark': theme_dark }]">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="emoji-block ">

          <div class="ub emoji-item" v-for="(item, index) in emoji_1" :key="index">
            <div class="ub ub-ac ub-pc ub-f1" v-for="sub_item in item" :key="sub_item.id" @click="tap_item(sub_item)">
                <img :src="sub_item.url" class="emoji-txt" />
            </div>
          </div>

        </div>
      </swiper-slide>

      <swiper-slide>
        <div class="emoji-block ">
          <div class="ub emoji-item" v-for="(item, index) in emoji_2" :key="index">
              <div class="ub ub-ac ub-pc ub-f1" v-for="sub_item in item" :key="sub_item.id" @click="tap_item(sub_item)">
                  <img :src="sub_item.url" class="emoji-txt" />
              </div>
          </div>
        </div>
      </swiper-slide>

      <div class="swiper-pagination" slot="scrollbar"></div>
    </swiper>
  </div>
</template>

<script>
  import * as tool from '../../api/common';
  //import const_data from '../../api/const_data';
  export default {
    name: "Swiper_Emoji",
    data() {
      return {
        emoji_1: [],
        emoji_2: [],

        swiperOption: {
          direction: 'horizontal',

          observeParents: true,   //观察父组件,当父组件变化时,自己随着变化
          observer: true,     //观察自己,自己的参数变化时,更新
          centeredSlides: true,   //设置为true时,活动块居中显示,默认下居左显示
          loop: false,   //滑动过程中会在前后复制多个slider,效果看起来是循环的
          loopedSlides: 3,   //设置滑动过程中所要用到的loop个数
          slidesPerView: 'auto',   //同时显示的slide数量
          loopAdditionalSlides: 100,
          autoPlay: {
            delay: 3000,
            disableOnInteraction: false  //鼠标移动上去时是否继续播放
          },
          pagination: { el: ".swiper-pagination" },
          paginationType: 'bullets',
          paginationElement: 'span'

        },
        theme_dark: false
      }
    },
    props: {},
    mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);

      this.init_page();
    },
    methods: {
      tap_item(item) {
        var item = { 'type': 'emoji', 'name': item.name, 'url': item.url }

        this.$emit("send_emoji", item)
      },
      init_page() {
          var const_data = this.$store.state.const_data;
          this.emoji_1 = tool.slice_arry(const_data.emoji_1, 5);
          this.emoji_2 = tool.slice_arry(const_data.emoji_2, 5);
      }
    }
  }
</script>

<style lang="scss" scoped>
.swiperbanner_container {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    background-color: #fff;
}
  .swiper-pagination {
    bottom: 2px !important;
  }

  .emoji-block {
    padding: .8rem;
    .emoji-item {
      height: 3rem;
      line-height: 3rem;
      justify-content: space-around;
      .emoji-txt {
        height: 2.5rem;
        width: 2.5rem;
      }
    }
  }

  .container-dark {
    background-color: #282828;
  }
</style>